import { GDFHotPollyTypes, GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const airmetsSigmets: Palette[] = [
    {
        id: GDFPalletCode.airmets,
        type: 'categorical',
        name: 'AIRMETs',
        withValues: true,
        entries: [
            {
                label: 'IFR (cig/vis)',
                color: '#990099',
                value: GDFHotPollyTypes.airmet_ifr
            },
            {
                label: 'Icing',
                color: '#0000ff',
                value: GDFHotPollyTypes.airmet_icing
            },
            {
                label: 'Surface turbulence (low)',
                color: '#cb3300',
                value: GDFHotPollyTypes.airmet_turb_sfc
            },
            {
                label: 'Turbulence aloft (high)',
                color: '#ff6600',
                value: GDFHotPollyTypes.airmet_turb_aloft
            },
            {
                label: 'Mountain obscuration',
                color: '#ff00ff',
                value: GDFHotPollyTypes.airmet_mtnobsc
            },
            {
                label: 'Surface wind',
                color: '#cc6600',
                value: GDFHotPollyTypes.airmet_wind_sfc
            },
            {
                label: 'Low level wind shear',
                color: '#993333',
                value: GDFHotPollyTypes.airmet_llws
            },
            {
                label: 'Freezing level',
                color: '#6666ff',
                value: GDFHotPollyTypes.airmet_freezing
            }
        ]
    },
    {
        id: GDFPalletCode.sigmets,
        type: 'categorical',
        name: 'SIGMETs',
        withValues: true,
        entries: [
            {
                label: 'Icing',
                color: 'rgb(0,0,128)',
                value: GDFHotPollyTypes.sigmet_icing
            },
            {
                label: 'Surface turbulence',
                color: 'rgb(160,96,0)',
                value: GDFHotPollyTypes.sigmet_turb_sfc
            },
            {
                label: 'Turbulence aloft',
                color: 'rgb(160,96,0)',
                value: GDFHotPollyTypes.sigmet_turb_aloft
            },
            {
                label: 'Visibility',
                color: 'rgb(255,255,255)',
                value: GDFHotPollyTypes.sigmet_visibility
            },
            {
                label: 'Volcanic ash',
                color: 'rgb(255,95,21)',
                value: GDFHotPollyTypes.sigmet_volcash
            },
            {
                label: 'Convective',
                color: 'rgb(128,0,0)',
                value: GDFHotPollyTypes.sigmet_conv
            },
            {
                label: 'Blowing dust',
                color: 'rgb(153,0,153)',
                value: GDFHotPollyTypes.sigmet_blowdust
            },
            {
                label: 'Blowing sand',
                color: 'rgb(153,0,153)',
                value: GDFHotPollyTypes.sigmet_blowsand
            },
            {
                label: 'Tropical cyclone',
                color: 'rgb(128,0,0)',
                value: GDFHotPollyTypes.sigmet_tropcyclone
            },
            {
                label: 'Thunderstorm',
                color: 'rgb(128,0,0)',
                value: GDFHotPollyTypes.sigmet_tstorm
            },
            {
                label: 'Mountain obscuration',
                color: 'rgb(255,255,255)',
                value: GDFHotPollyTypes.sigmet_mtnobsc
            },
            {
                label: 'Mountain wave',
                color: 'rgb(255,255,255)',
                value: GDFHotPollyTypes.sigmet_mtnwave
            },
            {
                label: 'Low level win shear',
                color: 'rgb(153,51,51)',
                value: GDFHotPollyTypes.sigmet_llws
            }
        ]
    },
    {
        id: GDFPalletCode.csigmets,
        type: 'categorical',
        name: 'Convective SIGMETs',
        withValues: true,
        entries: [
            {
                label: 'Convective Sigmet',
                color: 'rgb(255,0,0)',
                value: GDFHotPollyTypes.sigmet_conv
            }
        ]
    },
    {
        name: 'Ozone',
        id: GDFPalletCode.ozone,
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000000',
                hide: true
            },
            {
                label: '< 0.10',
                color: '#323232'
            },
            {
                label: '0.10 to 0.25',
                color: '#ffff00'
            },
            {
                label: '>= 0.25',
                color: '#ff9900'
            }
        ]
    },
    {
        id: GDFPalletCode.wsi_fpg,
        name: 'FPG (global; enroute hazards)',
        type: 'categorical',
        withValues: true,
        entries: [
            {
                label: 'IFR (cig/vis)',
                color: '#ff0000',
                value: GDFHotPollyTypes.airmet_ifr
            },
            {
                label: 'Icing',
                color: '#669aff',
                value: GDFHotPollyTypes.airmet_icing
            },
            {
                label: 'Surface turbulence (low)',
                color: '#ffff01',
                value: GDFHotPollyTypes.airmet_turb_sfc
            },
            {
                label: 'Turbulence aloft (high)',
                color: '#00dc00',
                value: GDFHotPollyTypes.airmet_turb_aloft
            },
            {
                label: 'Mountain obscuration',
                color: '#00dc00',
                value: GDFHotPollyTypes.airmet_mtnobsc
            },
            {
                label: 'Surface wind',
                color: '#ffffff',
                value: GDFHotPollyTypes.airmet_wind_sfc
            },
            {
                label: 'Low level wind shear',
                color: '#990001',
                value: GDFHotPollyTypes.airmet_llws
            },
            {
                label: 'Freezing level',
                color: '#6c90ca',
                value: GDFHotPollyTypes.airmet_freezing
            }
        ]
    }
];
